import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FlaskConical } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const ContactStrip = () => {
  const { lang } = useLang();
  const de = lang === 'de';
  return (
    <section className="bg-white border-t border-slate-200 py-14 lg:py-16">
      <div className="container-wide">
        <div className="max-w-4xl mx-auto rounded-2xl border border-slate-300 bg-slate-50 px-6 sm:px-10 py-8 lg:py-10 flex flex-col md:flex-row md:items-center gap-6 justify-between">
          <div className="flex items-start gap-5">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-blue-700/5 border border-blue-700/15 text-blue-700 shrink-0">
              <FlaskConical className="w-6 h-6" />
            </div>
            <div>
              <p className="text-lg font-bold text-slate-900 leading-snug">
                {de ? 'Technische Fragen zu Metakaolin?' : 'Technical questions about metakaolin?'}
              </p>
              <p className="mt-2 text-[14px] text-slate-600 leading-relaxed max-w-xl">
                {de
                  ? 'Sie entwickeln eine Rezeptur, bewerten einen Rohstoff oder planen eine konkrete Anwendung? Newchem unterst\u00fctzt bei der technischen Einordnung und der anwendungsspezifischen Eignungspr\u00fcfung.'
                  : 'Developing a mix design, assessing a raw material or planning a specific application? Newchem supports the technical assessment and application-specific suitability testing.'}
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-3 shrink-0">
            <Link
              to="/contact"
              data-testid="cta-contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-blue-700 text-white text-[14px] font-semibold hover:bg-blue-800 transition-colors"
            >
              {de ? 'Technische Beratung anfragen' : 'Request technical advice'}
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/newchem-kompetenz"
              data-testid="cta-competence"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white border border-slate-300 text-slate-800 text-[14px] font-semibold hover:border-blue-400 hover:text-blue-700 transition-colors"
            >
              {de ? 'Newchem Kompetenz ansehen' : 'View Newchem competence'}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactStrip;
